import { useMemo } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import clsx from "clsx";
import ZoomLevelButton from "../../../BottomMenuBar/ZoomLevelButton";
import OnVideoLocationView from "./OnVideoLocationView";
import StreamingParticipantName from "./StreamingParticipantName";
import DomainNameLogo from "./DomainNameLogo";
import { dualStreamEnabled, showZoomButton } from "../../../../shared/utility";
import ScreenShare from "../../../Twilio/ScreenShare/ScreenShare";
import zoomService from "../../../../services/zoomService";
import ScreenShareVideoButton from "./ScreenShareVideoButton";
import { EXTRACT_TEXT_VIEW, MARKUP_VIEW } from "../../../../constants/Constants";
import UploadFileButton from "./UploadFileButton";
import HomeScreenVideoButton from "./HomeScreenVideoButton";
import LivePointerMwebButton from "../../../LivePointer/LivePointerMwebButton";
import ReturnToGalleryViewButton from "../../../GalleryView/ReturnToGalleryViewButton";
import { GLOBAL_MEETING_DATA } from "../../../../constants/PublicVariables";
import SlickView from "../../../GalleryView/SlickView";
import useLanguageChange from "../../../../hooks/useLanguageChange";

const VideoScreen = () => {
    const { videoStreamingUsers, screenSharingUsers } = useSelector((state) => state.twilioEvents);
    const { extractTextInprogress } = useSelector((state) => state.extractText);
    const { markupInprogress } = useSelector((state) => state.markup);
    const { expandView } = useSelector((state) => state.commonReducer);
    const localisedValues = useLanguageChange();

    const isOCROrMarkupViewNotStarted = useMemo(() => {
        const isOCRViewNotStarted = extractTextInprogress !== EXTRACT_TEXT_VIEW.PREPARE_VIEW && extractTextInprogress !== EXTRACT_TEXT_VIEW.OCR_VIEW;
        const isMarkupViewNotStarted = markupInprogress !== MARKUP_VIEW.PREPARE_VIEW && markupInprogress !== MARKUP_VIEW.START_MARKUP_VIEW;

        return isOCRViewNotStarted && isMarkupViewNotStarted;
    }, [extractTextInprogress, markupInprogress]); // when OCR is on then don't show this view

    return (
        <>
            {isOCROrMarkupViewNotStarted && expandView && (
                <div className='video-call' id='video-call' data-testid='video-screen-com'>
                    {isEmpty(videoStreamingUsers) && isEmpty(screenSharingUsers) ? (
                        <div className='video-call-info' data-testid='video-call-info'>
                            <DomainNameLogo />
                            <div className='short-action-button'>
                                <HomeScreenVideoButton />
                                <ScreenShareVideoButton />
                                <UploadFileButton />
                            </div>
                        </div>
                    ) : (
                        <div
                            className={clsx(
                                "session-video-view",
                                screenSharingUsers.length > 0 && videoStreamingUsers.length === 0 && "share-screen-over"
                            )}
                            data-testid='video-screen'
                        >
                            <div id='canvasContainer' className='live-pointer-canvas-box'></div>
                            <div className='video-view' id='expandedVideo'>
                                {/* outremote_video */}
                                {/* {startLocalVideo && (
                                    
                                )} */}
                            </div>
                            {dualStreamEnabled() && expandView && <StreamingParticipantName localisedValues={localisedValues} />}
                            <OnVideoLocationView />
                            <div className='video-return-action'>
                                {dualStreamEnabled() && expandView && GLOBAL_MEETING_DATA.isAgent && <ReturnToGalleryViewButton />}
                                <LivePointerMwebButton />
                            </div>

                            {showZoomButton() && !zoomService.checkZoomButtonAvailable() && <ZoomLevelButton />}
                            <ScreenShare />
                            {dualStreamEnabled() && expandView && <SlickView />}
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default VideoScreen;
